import { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function PdfHtmlViewer() {
  const rawQuery = window.location.search.substring(1);

  const fileParam = rawQuery
    .split("&")
    .find((p) => p.startsWith("file="))
    ?.substring(5);

  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(800);

  const containerRef = useRef(null);

  function onLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    function updateWidth() {
      if (!containerRef.current) return;

      const width = containerRef.current.clientWidth;

      setPageWidth(Math.min(width - 16, 900));
    }

    updateWidth();

    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <div className="w-full h-screen bg-gray-100 overflow-auto">
      <div ref={containerRef} className="w-full flex flex-col items-center p-2">
        <Document
          file={fileParam}
          onLoadSuccess={onLoadSuccess}
          loading={<strong>Fetching document...</strong>}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <div
              key={index}
              className="mb-4 bg-white shadow rounded overflow-hidden"
            >
              <Page
                pageNumber={index + 1}
                width={pageWidth}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </div>
          ))}
        </Document>
      </div>
    </div>
  );
}
